export default __webpack_public_path__ + "static/media/sa.6c636a54.svg";